import { formatDate, formatDateRange } from "../../utils";

export const buildSearchCriteria = ({
    searchValue,
    repoFilters,
    filtersConditions,
}) => {
    const children = [];

    // MATCH (text search)
    if (searchValue) {
        children.push({
            type: "match",
            fieldName: "text",
            value: searchValue
        });
    }

    const processedRangeFields = new Set();

    Object.entries(repoFilters || {}).forEach(([fieldName, valueObj]) => {
        if (!valueObj) return;

        // TERMS
        if (valueObj?.value !== undefined) {
            children.push({
                type: "terms",
                fieldName,
                values: [valueObj.value]
            });
            return;
        }

        // -------------------
    // RANGE (Start/End pattern)
    // -------------------
    if (fieldName.endsWith('Start') || fieldName.endsWith('End')) {
        const baseField = fieldName.replace(/Start|End/, '');
  
        if (processedRangeFields.has(baseField)) return;
  
        const start = repoFilters[`${baseField}Start`];
        const end = repoFilters[`${baseField}End`];
  
        const condition = filtersConditions?.[baseField]?.value;
  
        if (condition === 'range' && start && end) {
          children.push({
            type: "range",
            fieldName: baseField,
            ...formatDateRange(start, end)
          });
  
          processedRangeFields.add(baseField);
          return;
        }
      }
  
      // -------------------
      // RANGE (single gte/lte)
      // -------------------
      const condition = filtersConditions?.[fieldName]?.value;

      if ((condition === 'gte' || condition === 'lte') && valueObj) {
        children.push({
          type: "range",
          fieldName,
          [condition]: formatDate(valueObj)
        });
      }

      // -------------------
      // RELATIVE DATE RANGE (withIn condition)
      // -------------------
      if (fieldName.endsWith('RelDateVal')) {
        const baseFieldName = fieldName.replace(/RelDateVal$/, '');
        const relDateField = `${baseFieldName}RelDate`;
        const relDateValField = `${baseFieldName}RelDateVal`;
        const timeUnit = filtersConditions?.[relDateField]?.value;
        const duration = repoFilters?.[relDateValField];

        if (timeUnit && duration) {
          children.push({
            type: "relDateRange",
            fieldName: baseFieldName,
            gtTimeUnit: timeUnit,
            gteDuration: -parseInt(duration)
          });
        }
      }
    });

    return {
        type: "and",
        children
    };
};